import { render, staticRenderFns } from "./engineer_doc_edit.vue?vue&type=template&id=bc1abb9e&scoped=true&"
import script from "./engineer_doc_edit.vue?vue&type=script&lang=js&"
export * from "./engineer_doc_edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc1abb9e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc1abb9e')) {
      api.createRecord('bc1abb9e', component.options)
    } else {
      api.reload('bc1abb9e', component.options)
    }
    module.hot.accept("./engineer_doc_edit.vue?vue&type=template&id=bc1abb9e&scoped=true&", function () {
      api.rerender('bc1abb9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_enginer/doc/edit/engineer_doc_edit.vue"
export default component.exports